module.exports = __webpack_public_path__ + "static/shotlists_setups@2x-cbc6c4475ce2e50d76d70fd28db5afcd.png";